/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prop_DueInputs */

const en_prop_due = /** @type {(inputs: Prop_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due date`)
};

const de_prop_due = /** @type {(inputs: Prop_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fälligkeit`)
};

/**
* | output |
* | --- |
* | "Due date" |
*
* @param {Prop_DueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const prop_due = /** @type {((inputs?: Prop_DueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prop_DueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_prop_due(inputs)
	return en_prop_due(inputs)
});